import React from "react";
import styles from "./MediaSection.module.scss";
import ArticleCard from "components/cards/articleCard/ArticleCard";

const MediaSection = () => {
  return (
    <div className={`mediaRef ${styles.mediaSectionContainer}`}>
      <div className="container">
        <div className={styles.title}>Media</div>
        <div className={styles.mediaList}>
          {Array.from(Array(4), (_, index) => (
            <ArticleCard key={index} />
          ))}
        </div>
        <div className={styles.loadMore}>
          <button>Load More</button>
        </div>
        <div className={styles.videoList}>
          {Array.from(Array(2), (_, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.video}>
                <iframe
                  src="https://www.youtube.com/embed/-FmR-BBmYfM?si=fhoif6x1KABuVQcZ"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
              <div className={styles.info}>
                <h2>Title Of The Work</h2>
                <p className={styles.desc}>
                  Contrary to popular belief, Lorem Ipsum is not simply random
                  text. It has roots in a piece of classical Latin literature
                  from 45 BC, making it over 2000 years old. Richard McClintock,
                  a Latin professor at Hampden-Sydney College in Virginia,
                  looked up one of the more obscure Latin words, consectetur,
                  from a Lorem Ipsum passage,and going through the cites of the
                  word in classical literature, discovered the undoubtable
                  source.
                </p>
                <div className={styles.date}>Name Lastname / 18 Aug, 2024</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MediaSection;
